import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import logoPais from '../../assets/pais/logoPais.png';
import botellaPais from '../../assets/pais/botellaPais.jpg'
import botanicosPais from '../../assets/pais/paisBotanicos.gif'
import botanicosPais2 from '../../assets/pais/paisBotanicos2.jpg'
import botanicosPais3 from '../../assets/pais/paisBotanicos3.jpg'
import instagram from '../../assets/logos/InstagramNegro.png'
import historiaPais from '../../assets/pais/HistoriaPais.gif';
import lata1 from '../../assets/pais/Lata1.png';
import lata2 from '../../assets/pais/Lata2.png';
import Mapa from '../../assets/pais/Mapa.png';
import vermut from '../../assets/cocktails/vermut.jpg'
import negroni from '../../assets/cocktails/Negroni.jpg'
import Carousel from 'react-bootstrap/Carousel';
import { Card, Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import videoPais from '../../assets/pais/HistoriaPais.mp4';

import ReactPlayer from 'react-player';


import { useTranslation } from 'react-i18next';

import flagEsp from '../../assets/logos/espana.png';
import flagUsa from '../../assets/logos/estados-unidos.png';
import flagChina from '../../assets/logos/china.png'
import mapaPais  from '../../assets/pais/mapa.png';

const styleNav = {
    textAlign: 'center'
};

function MainPais() {

    const { i18n, t } = useTranslation();

    return (
        <Container fluid style={{ backgroundColor: '#FCF0D6', fontFamily: 'Argent CF Regular' }}>
            <Row>
                <Navbar expand="lg" className="bg-body-white">
                    <Container>
                        <Navbar.Brand href="/">
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="ms-auto" style={styleNav}>
                                <Navbar.Brand onClick={() => { i18n.changeLanguage('es') }}>
                                    <img
                                        alt=""
                                        src={flagEsp}
                                        width="30"
                                        height="30"
                                        className="d-inline-block align-top"
                                    />{' '}
                                    ESP
                                </Navbar.Brand>
                                <Navbar.Brand onClick={() => { i18n.changeLanguage('en') }}>
                                    <img
                                        alt=""
                                        src={flagUsa}
                                        width="30"
                                        height="30"
                                        className="d-inline-block align-top"
                                    />{' '}
                                    ENG
                                </Navbar.Brand>
                                <Navbar.Brand onClick={() => { i18n.changeLanguage('zh') }}>
                                    <img
                                        alt=""
                                        src={flagChina}
                                        width="30"
                                        height="30"
                                        className="d-inline-block align-top"
                                    />{' '}
                                    ZH
                                </Navbar.Brand>
                            </Nav>

                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </Row>
            <Row>
                <Col xs={1} md={1}></Col>
                <Col md={5} style={{ marginTop: '30px', textAlign: 'center' }}>
                    <img
                        src={logoPais}
                        width="30%"
                        height="90%"
                        className="d-inline-block align-top"
                        alt="Pais"
                    />
                </Col>
                <Col md={6} style={{ marginTop: '50px', alignContent: 'center' }}>
                    <Row>
                        <Col md={12}>
                            <h5>{t('FollowUsOnOurNetworks')}</h5>
                            <hr />
                        </Col>
                        <Col md={2} style={{ height: '38px', width: '58px' }}>
                            <Link to='https://www.instagram.com/vermutpais/'>
                                <img
                                    src={instagram}
                                    width="100%"
                                    height="100%"
                                    className="d-inline-block align-top"
                                    alt="Aba logo"
                                />
                            </Link>
                        </Col>
                        <Col md={6} className="d-none d-lg-block" style={{ alignContent: 'center' }}><h5>@vermutpais</h5> </Col>
                        <hr />
                    </Row>

                </Col>
                <Col xs={1} md={1}></Col>
            </Row>
            <Row style={{ marginTop: '30px' }}>
                <Col xs={1} md={1}></Col>
                <Col md={4}>
                    <img
                        src={botellaPais}
                        width="100%"
                        height="100%"
                        className="d-inline-block align-top"
                        alt="Pais"
                    />
                </Col>
                <Col style={{ fontSize: '2rem', alignContent: 'center', fontFamily: 'Argent CF Regular', textAlign: 'justify' }} md={5}>
                    {/* <h2 style={{fontWeight: 'bold'}}>En una tierra de inmigrantes, muchas historias reunidas hacen un PAIS</h2> */}
                    <p>{t('paistText1')}</p>

                </Col>
            </Row>
            <hr className="d-md-none" />
            {/* Seccion 2 */}
            <Row style={{ marginTop: '30px' }}>
                <Col xs={1} md={2}></Col>
                <Col md={3} xs={12}>
                    <img
                        src={botanicosPais3}
                        width="100%"
                        height="100%"
                        className="d-inline-block align-top"
                        alt="Pais"
                        style={{ borderRadius: '30px' }}
                    />
                </Col>
                <Col xs={12} md={3} style={{ fontSize: '2rem', alignContent: 'center', fontFamily: 'Argent CF Regular', textAlign: 'justify', fontStyle: 'italic' }}><p>{t('paisText2')}</p></Col>
                <Col md={3}>
                    <img
                        src={botanicosPais2}
                        width="100%"
                        height="100%"
                        className="d-inline-block align-top"
                        alt="Pais"
                        style={{ borderRadius: '30px' }}
                    />
                </Col>
                <Col xs={1} md={3}></Col>
            </Row>

            {/* Seccion 2 Version Mobile */}
            {/* <Row style={ {marginTop: '30px'} }>
                <Col xs={1} md={2}></Col>
                <Col md={3} style={{fontSize: '1.5rem', alignContent: 'center', fontFamily: 'Syne Regular'}}><p>Vermut tipo Turín o Torino de color rojo oscuro, elaborado artesanalmente en base a vino blanco neutro con mas de 20 botánicos. 
                    Presenta un correcto balance entre dulce y amargo.</p></Col>
                <Col md={3}>
                    <img
                        src={botanicosPais3}
                        width="100%"
                        height="100%"
                        className="d-inline-block align-top"
                        alt="Pais"
                        style={{borderRadius : '30px'}}
                    />
                </Col>
                <Col md={3}>
                    <img
                        src={botanicosPais2}
                        width="100%"
                        height="100%"
                        className="d-inline-block align-top"
                        alt="Pais"
                        style={{borderRadius : '30px'}}
                    />
                </Col>
                <Col xs={1} md={1}></Col>
            </Row> */}
            <hr className="d-md-none" />
            <Row style={{ marginTop: '100px' }}>
                <Col xs={1} md={1}></Col>
                <Col style={{ textAlign: 'center' }} md={5} className="d-none d-lg-block">
                    {/* <img
                        src={historiaPais}
                        width="85%"
                        height="85%"
                        className="d-inline-block align-top"
                        alt="Pais"
                        style={{borderRadius : '30px'}}
                    /> */}
                    <ReactPlayer
                        url={videoPais}
                        controls={true}
                        width='100%'
                        height='800px'
                        loop={true}
                    ></ReactPlayer>

                </Col>
                {/* Version Mobile */}
                <Col style={{ textAlign: 'center' }} md={5} className="d-md-none">
                    <ReactPlayer
                        url={videoPais}
                        controls={true}
                        width='100%'
                        height='800px'
                        loop={true}
                    ></ReactPlayer>
                    {/* <img
                        src={historiaPais}
                        width="100%"
                        height="100%"
                        className="d-inline-block align-top"
                        alt="Pais"
                        style={{ borderRadius: '30px' }}
                    /> */}
                </Col>
                <Col md={5} style={{ marginTop: '30px' }}>
                    <h2 style={{ fontWeight: 'bold' }}>{t('paisSection1Title')}</h2>
                    <p style={{ fontSize: '2rem', alignContent: 'center', fontFamily: 'Argent CF Regular', textAlign: 'justify' }}>{t('paisSection1Text')}</p>
                </Col>
                <Col xs={1} md={1}></Col>
            </Row>
            <hr className="d-md-none" />
            <Row>
                <Col xs={1} md={1}></Col>
                <Col md={5} style={{ alignContent: 'center' }}>
                    <h2 style={{ fontWeight: 'bold' }}>{t('paisSection2Title')}</h2>
                    <p style={{ fontSize: '2rem', alignContent: 'center', fontFamily: 'Argent CF Regular', textAlign: 'justify' }}>{t('paisSection2Text')}</p>
                </Col>
                <Col md={5}>
                    <Carousel>
                        <Carousel.Item>
                            <img
                                src={lata1}
                                width="100%"
                                height="100%"
                                className="d-inline-block align-top"
                                alt="Pais"
                                style={{ borderRadius: '30px' }}
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                src={lata2}
                                width="100%"
                                height="100%"
                                className="d-inline-block align-top"
                                alt="Peregrino"
                                style={{ borderRadius: '30px' }}
                            />
                        </Carousel.Item>
                    </Carousel>
                </Col>
                <Col xs={1} md={1}></Col>
            </Row>
            <hr className="d-md-none" />
            <Row style={{ textAlign: 'center', padding: '5px', marginTop: '50px' }}>
                <Col xs={1} md={1}></Col>
                <Col md={10}><h2 style={{ fontWeight: 'bold' }}>{t('paissection3Title')}</h2></Col>
                <Col xs={1} md={1}></Col>
            </Row>
            <Row>
                <Col xs={1} md={1}></Col>
                <Col md={5} xs={12}>
                    <img
                        src={mapaPais}
                        width="100%"
                        height="100%"
                        className="d-inline-block align-top"
                        alt="Peregrino"
                        style={{ borderRadius: '30px' }}
                    />
                </Col>
                <Col md={5} xs={12} style={{fontSize: '2rem', alignContent: 'center'}}><p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum non praesentium totam? Praesentium quisquam doloremque, sint reiciendis, a possimus libero iure obcaecati deleniti quibusdam laborum incidunt quo nihil quas sunt!</p></Col>
                <Col xs={6} md={1}></Col>
            </Row>
            <hr className="d-md-none" />
            <Row style={{ marginTop: '30px', textAlign: 'center' }}>
                <Col xs={1} md={1}></Col>
                <Col md={10}><h2 style={{ fontWeight: 'bold' }}>{t('cocktails')}</h2></Col>
                <Col xs={1} md={1}></Col>
            </Row>
            <Row style={{ padding: '5px', textAlign: 'center' }}>
                <Col xs={1} md={1}></Col>
                <Col xs={12} md={4}>
                    <Card style={{ width: '100%' }}>
                        <Card.Img variant="top" src={vermut} />
                        <Card.Body>
                            <Card.Title>{t('Vermút')}</Card.Title>
                            <Card.Text>
                                {t('ingredientsVermut')}
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={4}>
                    <Card style={{ width: '100%' }}>
                        <Card.Img variant="top" src={negroni} />
                        <Card.Body>
                            <Card.Title>{t('negroniAba')}</Card.Title>
                            <Card.Text>
                                {t('ingredientsNegroniAba')}
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default MainPais;